/**
 * ユーザー
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'
 
 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/users`
 
 const search_user = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
     index (context, params) {
       return new Promise((resolve) => {
         Vue.$http.get(API_PATH, { params }).then(data => {
           resolve(data.content)
         })
       })
     },
   },
   mutations: {},
 }
 export default search_user
 